// extracted by mini-css-extract-plugin
export var active = "_1v-7";
export var backButton = "_1v-6";
export var collapseBar = "_1v-f";
export var collapseMode = "_1v-h";
export var dragHandle = "_1v-a";
export var dropdownIcon = "_1v-d";
export var hidden = "_1v-n";
export var iconContainer = "_1v-k";
export var iconSwapper = "_1v-m";
export var navItem = "_1v-4";
export var navItemIcon = "_1v-c";
export var navProfile = "_1v-5";
export var notificationDot = "_1v-l";
export var optionsContainer = "_1v-e";
export var primaryNav = "_1v-0";
export var primaryTab = "_1v-i";
export var secondaryNav = "_1v-1";
export var selected = "_1v-j";
export var settingsNav = "_1v-2";
export var settingsNavItems = "_1v-3";
export var show = "_1v-b";
export var sideNav = "_1v-g";
export var teamItem = "_1v-8";
export var userProfileItem = "_1v-9";